import { z } from 'zod'

//
// MB2 outbound webhook の受信ボディを検証する zod スキーマ。
// 保存は payload 全体を verbatim（加工なし）で行うため、未知キーを落とさない loose object を使う。
// 逆引きに使う group_id / mill_sheet_id だけを型付けし、その他はそのまま透過させる。
//
export const mb2WebhookPayloadSchema = z.looseObject({
  id: z.string(),
  type: z.string(),
  occurred_at: z.string(),
  data: z.looseObject({
    group_id: z.number().optional(),
    mill_sheet_id: z.number().optional(),
  }),
  context: z.record(z.string(), z.unknown()).optional(),
})
